import Footer from '@package/components/theme/Footer/Footer';

export default Footer;
